import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Spinner = props => (
  <div
    id="spinner"
    {...css(props.styles.spinner, props.styles[`spinner--${props.type}`])}
  >
    <div
      {...css(
        props.styles['spinner-dots']
        /*props.type === 'local' && props.styles['spinner-dots--local']*/
      )}
    />
  </div>
)

Spinner.propTypes = {
  type: PropTypes.oneOf(['global', 'step', 'local']).isRequired,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Spinner)



// WEBPACK FOOTER //
// ./components/spinner/index.js